// ConnectivityTester/testConfig.ts

/**
 * Hardcoded configuration derived from the legacy 'vt.json' response,
 * representing test limits for 'Virtual Training' (VT).
 */
const TEST_CONFIG = {
  // Bandwidth limits in Kbps. These are the effective limits used for comparison.
  bw_poor_limit: 1000,
  bw_good_limit: 2000,

  // Latency limits in ms.
  lat_poor_limit: 250,
  lat_good_limit: 125,

  // Resolution limits (from vt.json: "config.xres = 1280; config.yres = 800;")
  xres: 1280,
  yres: 800,

  wss_test_url:
    'wss://s3284.nyc3.piesocket.com/v3/1?api_key=Ph3rw6dNvFicOLTWVtl1ACATO0TK1LL3d9y74Jdj&notify_self',
};

export default TEST_CONFIG;
